export enum ProductSearchMode { partNumber, description, supplierPartNumber };
export interface ISearchProducts {
    partNumber?: string,
    description?: string|undefined,
    supplierPartNumber?: string|undefined,
    includeTurnedDown?: boolean,
    includeComponentParts?: boolean,
    siteCode?: string
    currentPage?: number;
    rowsPerPage?: number;
    mode?: ProductSearchMode
}